<template>
  <div
    id="live-calls-container"
    class="page-content live-calls-container"
  >
    <live-calls-table />
    <supervisor-pending-calls-table />
    <outbound-calls-table />
    <missed-calls-table />
    <online-operators />
    <offline-operators />
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const OnlineOperators = defineAsyncComponent(() => import('./LiveCalls/OnlineOperators.vue') as any);

const LiveCallsTable = defineAsyncComponent(() => import('./LiveCalls/LiveCallsTable.vue') as any);

const SupervisorPendingCallsTable = defineAsyncComponent(() => import('./LiveCalls/SupervisorPendingCallsTable.vue') as any);

const OutboundCallsTable = defineAsyncComponent(() => import('./LiveCalls/OutboundCallsTable.vue') as any);

const OfflineOperators = defineAsyncComponent(() => import('./LiveCalls/OfflineOperators.vue') as any);

const MissedCallsTable = defineAsyncComponent(() => import('./LiveCalls/MissedCallsTable.vue') as any);

const route = useRoute();

onMounted(async () => {
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
